import { z } from 'zod';

/** Four-digit dashboard PIN. */
export const dashboardPinSchema = z
  .string()
  .regex(/^\d{4}$/, 'PIN должен состоять из 4 цифр');

export const dashboardUnlockRequestSchema = z.object({
  pin: dashboardPinSchema,
});
export type DashboardUnlockRequest = z.infer<typeof dashboardUnlockRequestSchema>;

export const dashboardStatusSchema = z.object({
  enabled: z.boolean(),
  unlocked: z.boolean(),
});
export type DashboardStatus = z.infer<typeof dashboardStatusSchema>;

export const dashboardTodayTaskSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  done: z.boolean(),
  timeHours: z.number().nonnegative(),
  projectName: z.string(),
  clientName: z.string(),
  assigneeName: z.string().nullable(),
});
export type DashboardTodayTask = z.infer<typeof dashboardTodayTaskSchema>;

export const dashboardMonthProgressPointSchema = z.object({
  date: z.string(),
  day: z.number().int().positive(),
  /** Cumulative % of monthly break-even hours completed (billable at min rate). */
  completedPct: z.number().nonnegative(),
  /** Ideal cumulative % by this workday (Mon–Fri linear month tempo). */
  idealPct: z.number().min(0).max(100),
});
export type DashboardMonthProgressPoint = z.infer<typeof dashboardMonthProgressPointSchema>;

export const dashboardMonthProgressSchema = z.object({
  monthKey: z.string(),
  monthLabel: z.string(),
  lastDay: z.number().int().positive(),
  points: z.array(dashboardMonthProgressPointSchema),
  /** Pace vs expected break-even tempo (100% = on track). */
  currentPct: z.number().nonnegative(),
  breakEvenHours: z.number().nonnegative(),
  minBillingRate: z.number().nonnegative(),
  /** False when break-even cannot be computed (no billing rates). */
  configured: z.boolean(),
});
export type DashboardMonthProgress = z.infer<typeof dashboardMonthProgressSchema>;

export const dashboardEmployeeSchema = z.object({
  userId: z.string().uuid(),
  name: z.string(),
  title: z.string(),
  openHours: z.number().nonnegative(),
  doneHours: z.number().nonnegative(),
  openCount: z.number().int().nonnegative(),
  doneCount: z.number().int().nonnegative(),
  overdueCount: z.number().int().nonnegative(),
  allocatedHours: z.number().nonnegative(),
  allocPct: z.number().nonnegative(),
});
export type DashboardEmployee = z.infer<typeof dashboardEmployeeSchema>;

export const dashboardOverviewSchema = z.object({
  total: z.number().int().nonnegative(),
  done: z.number().int().nonnegative(),
  open: z.number().int().nonnegative(),
  overdue: z.number().int().nonnegative(),
  dueToday: z.number().int().nonnegative(),
  unassignedOpen: z.number().int().nonnegative(),
  activeClients: z.number().int().nonnegative(),
  activeProjects: z.number().int().nonnegative(),
  todayTasks: z.array(dashboardTodayTaskSchema),
  employees: z.array(dashboardEmployeeSchema),
  monthProgress: dashboardMonthProgressSchema,
  updatedAt: z.string(),
});
export type DashboardOverview = z.infer<typeof dashboardOverviewSchema>;
